import styled from "styled-components";

export const CategoriesDesktop = styled.ul`
    position: relative;

    display: flex;
    flex-wrap: wrap;
    width: 90%;
    max-width: 1200px;
    margin: 70px auto;
    overflow: hidden;

    list-style: none;
`;

export const OffscreenTitle = styled.h2`
    position: absolute;
    left: 100vw;

    opacity: 0;
`;

export const Item = styled.li`
    width: calc(25% - 20px);

    margin: 0 10px 70px;
`;

export const Title = styled.h3`
    margin-left: 20px;

    font-weight: normal;
    font-size: 20px;
    line-height: 30px;
`;

export const Questions = styled.ul`
    list-style: none;
`;

export const Question = styled.li`
    margin-bottom: 13px;
    padding-bottom: 13px;

    font-size: 15px;
    line-height: 25px;

    border-bottom: 1px solid rgba(0, 23, 75, 0.1);
`;

export const StyledLink = styled.a`
    color: var(--color-darkNight);

    transition: 0.1s color ease-in-out;

    &:hover,
    &:visited {
        color: var(--color-lightNight);
    }
`;
